import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "./api";

const routePermissions = {
  "/": "dashboard",
  "/about-us": "aboutus",
  "/advertisment": "advertisement",
  "/circular": "circular",
  "/application": "application",
  "/students": "student",
  "/existingstudent": "existing_student",
  "/teacher": "teacher",
  "/fee_setup": "fee",
  "/fee_report": "fee",
  "/fee_report/:id": "fee",
  "/new_admission": "new_admission",
  "/add_user": "role",
  "/add_role": "role",
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("accessToken");
      const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
      const userType = localStorage.getItem("userType");

      if (!token) {
        setAuthenticated(false);
        setLoading(false);
        return;
      }

      setAuthenticated(true);

      if (userType === "accessUser") {
        const currentPath = location.pathname.split("/")[1] || "/";
        const basePath = location.pathname.startsWith("/fee_report/")
          ? "/fee_report/:id"
          : location.pathname;

        const requiredPermission =
          routePermissions[basePath] || routePermissions[`/${currentPath}`];

        const isAuthorized = !requiredPermission || permissions.includes(requiredPermission);
        setAuthorized(isAuthorized);

        // If not authorized, find the first route they have access to
        if (!isAuthorized) {
          const firstAuthorizedRoute = Object.keys(routePermissions).find(route => {
            const permission = routePermissions[route];
            return permissions.includes(permission);
          });
          
          setRedirectPath(firstAuthorizedRoute || "/login");
        }
      } else {
        setAuthorized(true);
      }
      setLoading(false);
    };

    checkAuth();
  }, [location]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!authenticated) return <Navigate to="/login" replace />;
  
  if (!authorized && redirectPath) {
    // Prevent infinite loop by only redirecting if we're not already on the redirect path
    if (location.pathname !== redirectPath) {
      return <Navigate to={redirectPath} replace />;
    }
    // If we're already on the redirect path but still not authorized, show error
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        padding: '20px'
      }}>
        <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>Unauthorized Access</h1>
        <p style={{ fontSize: '18px', color: '#6c757d', marginBottom: '30px', textAlign: 'center' }}>
          You don't have permission to access any pages. Please contact your administrator.
        </p>
        <button 
          onClick={() => {
            localStorage.clear();
            window.location.href = '/login';
          }}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Logout and Return to Login
        </button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
